import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Row, Col } from 'react-flexbox-grid'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputBase from '@material-ui/core/InputBase';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PlacesAutocomplete from 'react-places-autocomplete';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import './styles.css'

const styles = theme => ({
  label: {
    font: '500 16px/20px Poppins',
    letterSpacing: '0px',
    color: '#0C3653',
  },
  rootContent:{
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '-5px 4px 10px #8E8E8E29',
    borderRadius: '21px',
    opacity: 1,
    minWidth: '300px',
    padding: '0px !important'
},
})



const styledMapType = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
]

const RadioOrange = withStyles({
  root: {
      color: '#AC242D',
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

class DomicilioEntrega extends React.Component {


  constructor(props) {
    super(props)

    this.state = {
    }

    this.refMarker = React.createRef();

    this.searchOptions = {
      types: ['address'],
      componentRestrictions: {country: 'ar'},
      location: new this.props.google.maps.LatLng(-31.638377, -60.7041932),
      radius: 2000,
      strictbounds: true,
    }

    this.triangleCoords = new this.props.google.maps.LatLngBounds(
      new this.props.google.maps.LatLng(-31.69418519541133, -60.80793502617186),
      new this.props.google.maps.LatLng(-31.60299866857677, -60.66785934257811)
      )
  }
  
  _mapLoaded = (mapProps, map) => {
    map.setOptions({
       styles: styledMapType
    })
  } 

  renderMarkers() {
        return <Marker
                  position = {this.props.position}
                />
  }

  handleOnClickUbicacion = () => {
    let geocoder = new this.props.google.maps.Geocoder();
    
    this.props.handleOnClickUbicacion(1, undefined, geocoder)
  }

  moveMarker = (e) => {
    
    let geocoder = new this.props.google.maps.Geocoder();
      
    let pos = this.refMarker.current.marker.getPosition()

    let position = {}

    if(pos){
      position.lat = pos.lat()
      position.lng = pos.lng()
    }
    
    this.props.moveMarker(geocoder, position)
  }
  
  markerChangePosition = (e) => {
    if(e){
      
    }
    
  }
  
  render() {
    
    const { classes } = this.props;

    return (
        <div className='containerDomicilioEntrega'>

          {this.props.esGeorreferenciacion === false && this.props.domicilios && this.props.domicilios.length > 0 
          && this.props.tipoUbicacionElegida === undefined && 
          <div className='containerDomiciliosOptions'>
              {this.props.domicilios.map((de) => {
                return <div className='containerRadioBtn'>
                        <FormControlLabel onChange={() => this.props.handleChangeRadioButton(de.idDomicilioEntrega.toString())} classes={{label: classes.label}} value={de.idDomicilioEntrega.toString()} control={<RadioOrange />} label={de.domicilio + " " + (de.pisoDepto ? de.pisoDepto : '')} />
                      </div>
              })}

            <div className='containerBtnsForm'>
              <div className={`btn`} onClick={() => this.props.handleOnClickUbicacion(2)}>Agregar domicilio</div>
            </div>                                   
          </div>
          }

          {(this.props.esGeorreferenciacion === true || (this.props.tipoUbicacionElegida || (this.props.tipoUbicacionElegida === undefined && 
          (this.props.domicilios === undefined || this.props.domicilios === null || (this.props.domicilios && this.props.domicilios.length === 0))))) && 
          <div className='containerFormMap'>
            <div className='containerForm'>
              
              <Row>
                <Col xs={12}>
                  <div className='inputContainer inputAutocomplete'>
                    {<span class="label">Calle, número y ciudad</span>}
                    <PlacesAutocomplete
                      value={this.props.formUbicacion.domicilio}
                      onChange={this.props.handleChangeAutocomplete}
                      onSelect={this.props.handleSelect}
                      searchOptions={this.searchOptions}
                    >
                      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div>
                          <input
                            {...getInputProps({
                              placeholder: 'Calle, número y ciudad',
                              className: 'location-search-input',
                            })}
                          />
                          <div className={`autocomplete-dropdown-container ${loading || suggestions.length > 0 ? 'containerSugerencias' : ''}`}>
                            {loading && <div className='itemSugerencia'>Loading...</div>}
                            {suggestions.map(suggestion => {
                              const className = suggestion.active
                                ? 'suggestion-item--active'
                                : 'suggestion-item';
                              // inline style for demonstration purpose
                              const style = suggestion.active
                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                
                              if(suggestion.types && suggestion.types.includes("street_address")){
                                  return <div
                                  {...getSuggestionItemProps(suggestion, {
                                    className,
                                    style,
                                  })}
                                  className='itemSugerencia'
                                >
                                  <span>{suggestion.description}</span>
                                </div>
                              }
                              else{
                                return undefined
                              }
                            })}
                          </div>
                        </div>
                      )}
                    </PlacesAutocomplete>
                    {this.props.errores.domicilio !== undefined &&
                        <FormHelperText error>{this.props.errores.domicilio}</FormHelperText>}
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                    <div className='inputContainer'>
                        <span class="label">Piso, departamento</span>
                        <InputBase  
                            placeholder="Piso, departamento"
                            value={this.props.formUbicacion.pisoDepto}
                            onChange={this.props.handleChangeForm}
                            name="pisoDepto"
                            error={this.props.errores.pisoDepto !== undefined}
                        />
                    </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                    <div className='inputContainer'>
                        <span class="label">CP</span>
                        <InputBase  
                            placeholder="CP"
                            value={this.props.formUbicacion.cp}
                            onChange={this.props.handleChangeForm}
                            name="cp"
                            error={this.props.errores.cp !== undefined}
                            disabled={true}
                        />
                        
                        {this.props.errores.cp !== undefined &&
                        <FormHelperText error>{this.props.errores.cp}</FormHelperText>}
                    </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                    <div className='inputContainer'>
                        <span class="label">Localidad</span>
                        <InputBase  
                            placeholder="Localidad"
                            value={this.props.formUbicacion.localidad}
                            onChange={this.props.handleChangeForm}
                            name="localidad"
                            error={this.props.errores.localidad !== undefined}
                            disabled={true}
                        />
                        
                        {this.props.errores.localidad !== undefined &&
                        <FormHelperText error>{this.props.errores.localidad}</FormHelperText>}
                    </div>
                </Col>
              </Row>

              <Row>
                <Col xs={12}>
                    <div className='inputContainer'>
                        <span class="label">Opcional</span>
                        <InputBase  
                            placeholder="Opcional. Ejemplo: planta alta"
                            value={this.props.formUbicacion.opcional}
                            onChange={this.props.handleChangeForm}
                            name="opcional"
                        />
                    </div>
                </Col>
              </Row>

              <div className='containerBtnsForm'>
                {this.props.esGeorreferenciacion === false && <div className={`btn btnSmall`} onClick={() => this.props.handleOnClickUbicacion(undefined, true)}>CANCELAR</div>}
                <div className={`btn btnSmall`} onClick={this.props.handleOnClickSave}>GUARDAR</div>
              </div>
              
            </div>

            <div className="containerMap">
              <Map
                zoom={this.props.zoom}
                google={this.props.google}
                style={{                
                  width: 250,
                  height: 350,
                  position: "relative"}}
                initialCenter={{lat: this.props.position.lat, lng: this.props.position.lng }}
                center={{lat: this.props.position.lat, lng: this.props.position.lng }}
                onReady={(mapProps, map) => this._mapLoaded(mapProps, map)}
              >
                {this.props.existeSeleccion && 
                <Marker 
                  position = {this.props.position}
                  onClick={this.onMarkerClick}
                  name={'Current location'}
                  draggable={true}
                  onDragend={this.moveMarker.bind(this)}
                  ref={this.refMarker}
                />}
              </Map>
            </div>

          </div>}

          {/* MODAL CONFIRMACION DE PEDIDO */}
          <Dialog
              classes={{paperScrollPaper: classes.rootContent}}
              open={this.props.openModalBorrarDireccion}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              maxWidth='sm'
              fullWidth={true}
          >
              <DialogContent classes={{root: classes.rootContent}}>
                  <Row style={{margin: '0px'}}>

                      <Col  xs={12} md={12} lg={12}  style={{padding: '0px'}}>
                          <div className='deleteDireccion'>                          
                              <div className='containerDeleteDireccion'>
                                  
                                  <div className='labelDescripcion'>
                                      Esta seguro que desea eliminar su dirección?
                                  </div>

                                  <div className='buttonContainer'>
                                    <Button className='btnCancelar' onClick={() => this.props.handleOnClickDeleteDireccion(undefined, undefined, true) }>CANCELAR</Button>
                                    <Button onClick={() => this.props.handleOnClickDeleteDireccion(undefined, true, undefined)}>ELIMINAR</Button>
                                  </div>

                              </div>
                          </div>
                      </Col>
                  </Row>
              </DialogContent>
          </Dialog>

        </div>
    );
  }
}

DomicilioEntrega.defaultProps = {
  domicilios: [],
  esGeorreferenciacion: false,
  openModalBorrarDireccion: false,
  handleOnClickUbicacion: f => f,
  handleSelect: f => f,
  handleChangeAutocomplete: f => f,
  handleChangeForm: f => f,
  handleChangeRadioButton: f => f,
  handleOnClickSave: f => f,
  handleOnClickDeleteDireccion: f => f,
  moveMarker: f => f,
}

DomicilioEntrega.propTypes = {
  domicilios: PropTypes.array.isRequired,
  domicilioSeleccionado: PropTypes.string.isRequired,
  esGeorreferenciacion: PropTypes.bool.isRequired,
  tipoUbicacionElegida: PropTypes.number.isRequired,
  position: PropTypes.object.isRequired,
  zoom: PropTypes.number.isRequired,
  existeSeleccion: PropTypes.bool.isRequired,
  formUbicacion: PropTypes.object.isRequired,
  errores: PropTypes.object.isRequired,
  openModalBorrarDireccion: PropTypes.bool.isRequired,
  handleOnClickUbicacion: PropTypes.func.isRequired,
  handleSelect: PropTypes.func.isRequired,
  handleChangeAutocomplete: PropTypes.func.isRequired,
  handleChangeForm: PropTypes.func.isRequired,
  handleChangeRadioButton: PropTypes.func.isRequired,
  handleOnClickSave: PropTypes.func.isRequired,
  handleOnClickDeleteDireccion: PropTypes.func.isRequired,
  moveMarker: PropTypes.func.isRequired,
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyAGe37J-Cp4mPYGC_dt-ykvOPCa2HgcR_8",
  libraries: ['places'],
  v: "3",
  language: "es",
})(withStyles(styles)(DomicilioEntrega))

